// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:where(.vuetify-styles) .v-slider-thumb {
  touch-action: none;
  color: rgb(var(--v-theme-surface-variant));
}
:where(.vuetify-styles) .v-input--error:not(.v-input--disabled) .v-slider-thumb {
  color: inherit;
}

:where(.vuetify-styles) .v-slider-thumb__label {
  background: rgba(var(--v-theme-surface-variant), 0.7);
  color: rgb(var(--v-theme-on-surface-variant));
}
:where(.vuetify-styles) .v-slider-thumb__label > .v-slider-thumb__label-wedge {
  background: inherit;
}

:where(.vuetify-styles) .v-slider-thumb {
  outline: none;
  position: absolute;
  transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
}

:where(.vuetify-styles) .v-slider-thumb__surface {
  cursor: pointer;
  width: var(--v-slider-thumb-size);
  height: var(--v-slider-thumb-size);
  border-radius: 50%;
  -webkit-user-select: none;
          user-select: none;
  background-color: currentColor;
}
@media (forced-colors: active) {
  :where(.vuetify-styles) .v-slider-thumb__surface {
    background-color: highlight;
  }
}
:where(.vuetify-styles) .v-slider-thumb__surface::before {
  transition: 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  content: "";
  color: inherit;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border-radius: 50%;
  background: currentColor;
  position: absolute;
  pointer-events: none;
  opacity: 0;
}
:where(.vuetify-styles) .v-slider-thumb__surface::after {
  content: "";
  width: 42px;
  height: 42px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

:where(.vuetify-styles) .v-slider-thumb__label-container {
  position: absolute;
  transition: 0.2s cubic-bezier(0.4, 0, 1, 1);
}

:where(.vuetify-styles) .v-slider-thumb__label {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.75rem;
  min-width: 35px;
  height: 25px;
  border-radius: 4px;
  padding: 6px;
  position: absolute;
  -webkit-user-select: none;
          user-select: none;
  transition: 0.2s cubic-bezier(0.4, 0, 1, 1);
}
:where(.vuetify-styles) .v-slider-thumb__label > .v-slider-thumb__label-wedge {
  width: 12px;
  height: 12px;
  position: absolute;
}

:where(.vuetify-styles) .v-slider-thumb__ripple {
  position: absolute;
  left: calc(var(--v-slider-thumb-size) / -2);
  top: calc(var(--v-slider-thumb-size) / -2);
  width: calc(var(--v-slider-thumb-size) * 2);
  height: calc(var(--v-slider-thumb-size) * 2);
  background: inherit;
}

:where(.vuetify-styles) .v-slider.v-input--horizontal .v-slider-thumb {
  top: 50%;
  transform: translateY(-50%);
  inset-inline-start: calc(var(--v-slider-thumb-position) - var(--v-slider-thumb-size) / 2);
}
:where(.vuetify-styles) .v-slider.v-input--horizontal .v-slider-thumb__label-container {
  left: calc(var(--v-slider-thumb-size) / 2);
  top: 0;
}
:where(.vuetify-styles) .v-slider.v-input--horizontal .v-slider-thumb__label {
  bottom: calc(var(--v-slider-thumb-size) / 2);
}
:where(.vuetify-styles) .v-locale--is-ltr.v-slider.v-input--horizontal .v-slider-thumb__label, :where(.vuetify-styles) .v-locale--is-ltr .v-slider.v-input--horizontal .v-slider-thumb__label {
  transform: translateX(-50%);
}

:where(.vuetify-styles) .v-locale--is-rtl.v-slider.v-input--horizontal .v-slider-thumb__label, :where(.vuetify-styles) .v-locale--is-rtl .v-slider.v-input--horizontal .v-slider-thumb__label {
  transform: translateX(50%);
}

:where(.vuetify-styles) .v-slider.v-input--horizontal .v-slider-thumb__label > .v-slider-thumb__label-wedge {
  clip-path: polygon(50% 100%, 0 50%, 100% 50%);
  bottom: calc(-6px + 0.2px);
}

:where(.vuetify-styles) .v-slider.v-input--vertical .v-slider-thumb {
  top: calc(var(--v-slider-thumb-position) - var(--v-slider-thumb-size) / 2);
}
:where(.vuetify-styles) .v-slider.v-input--vertical .v-slider-thumb__label-container {
  top: calc(var(--v-slider-thumb-size) / 2);
  right: 0;
}
:where(.vuetify-styles) .v-slider.v-input--vertical .v-slider-thumb__label {
  top: -12.5px;
  left: calc(var(--v-slider-thumb-size) / 2);
}
:where(.vuetify-styles) .v-slider.v-input--vertical .v-slider-thumb__label > .v-slider-thumb__label-wedge {
  clip-path: polygon(0 50%, 50% 0, 50% 100%);
  left: calc(-6px + 0.2px);
}

:where(.vuetify-styles) .v-slider-thumb--focused .v-slider-thumb__surface::before {
  transform: scale(2);
  opacity: var(--v-focus-opacity);
}

:where(.vuetify-styles) .v-slider-thumb--pressed {
  transition: none;
}
:where(.vuetify-styles) .v-slider-thumb--pressed .v-slider-thumb__surface::before {
  opacity: var(--v-pressed-opacity);
}

@media (hover: hover) {
  :where(.vuetify-styles) .v-slider-thumb:hover .v-slider-thumb__surface::before {
    transform: scale(2);
  }
  :where(.vuetify-styles) .v-slider-thumb:hover:not(.v-slider-thumb--focused) .v-slider-thumb__surface::before {
    opacity: var(--v-hover-opacity);
  }
}`, "",{"version":3,"sources":["webpack://./node_modules/vuetify/lib/components/VSlider/VSliderThumb.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,0CAA0C;AAC5C;AACA;EACE,cAAc;AAChB;;AAEA;EACE,qDAAqD;EACrD,6CAA6C;AAC/C;AACA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,gDAAgD;AAClD;;AAEA;EACE,eAAe;EACf,iCAAiC;EACjC,kCAAkC;EAClC,kBAAkB;EAClB,yBAAiB;UAAjB,iBAAiB;EACjB,8BAA8B;AAChC;AACA;EACE;IACE,2BAA2B;EAC7B;AACF;AACA;EACE,6CAA6C;EAC7C,WAAW;EACX,cAAc;EACd,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,wBAAwB;EACxB,kBAAkB;EAClB,oBAAoB;EACpB,UAAU;AACZ;AACA;EACE,WAAW;EACX,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,yBAAiB;UAAjB,iBAAiB;EACjB,2CAA2C;AAC7C;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,2CAA2C;EAC3C,0CAA0C;EAC1C,2CAA2C;EAC3C,4CAA4C;EAC5C,mBAAmB;AACrB;;AAEA;EACE,QAAQ;EACR,2BAA2B;EAC3B,yFAAyF;AAC3F;AACA;EACE,0CAA0C;EAC1C,MAAM;AACR;AACA;EACE,4CAA4C;AAC9C;AACA;EACE,2BAA2B;AAC7B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,6CAA6C;EAC7C,0BAA0B;AAC5B;;AAEA;EACE,0EAA0E;AAC5E;AACA;EACE,yCAAyC;EACzC,QAAQ;AACV;AACA;EACE,YAAY;EACZ,0CAA0C;AAC5C;AACA;EACE,0CAA0C;EAC1C,wBAAwB;AAC1B;;AAEA;EACE,mBAAmB;EACnB,+BAA+B;AACjC;;AAEA;EACE,gBAAgB;AAClB;AACA;EACE,iCAAiC;AACnC;;AAEA;EACE;IACE,mBAAmB;EACrB;EACA;IACE,+BAA+B;EACjC;AACF","sourcesContent":[".v-slider-thumb {\n  touch-action: none;\n  color: rgb(var(--v-theme-surface-variant));\n}\n.v-input--error:not(.v-input--disabled) .v-slider-thumb {\n  color: inherit;\n}\n\n.v-slider-thumb__label {\n  background: rgba(var(--v-theme-surface-variant), 0.7);\n  color: rgb(var(--v-theme-on-surface-variant));\n}\n.v-slider-thumb__label > .v-slider-thumb__label-wedge {\n  background: inherit;\n}\n\n.v-slider-thumb {\n  outline: none;\n  position: absolute;\n  transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);\n}\n\n.v-slider-thumb__surface {\n  cursor: pointer;\n  width: var(--v-slider-thumb-size);\n  height: var(--v-slider-thumb-size);\n  border-radius: 50%;\n  user-select: none;\n  background-color: currentColor;\n}\n@media (forced-colors: active) {\n  .v-slider-thumb__surface {\n    background-color: highlight;\n  }\n}\n.v-slider-thumb__surface::before {\n  transition: 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n  content: \"\";\n  color: inherit;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  border-radius: 50%;\n  background: currentColor;\n  position: absolute;\n  pointer-events: none;\n  opacity: 0;\n}\n.v-slider-thumb__surface::after {\n  content: \"\";\n  width: 42px;\n  height: 42px;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n}\n\n.v-slider-thumb__label-container {\n  position: absolute;\n  transition: 0.2s cubic-bezier(0.4, 0, 1, 1);\n}\n\n.v-slider-thumb__label {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 0.75rem;\n  min-width: 35px;\n  height: 25px;\n  border-radius: 4px;\n  padding: 6px;\n  position: absolute;\n  user-select: none;\n  transition: 0.2s cubic-bezier(0.4, 0, 1, 1);\n}\n.v-slider-thumb__label > .v-slider-thumb__label-wedge {\n  width: 12px;\n  height: 12px;\n  position: absolute;\n}\n\n.v-slider-thumb__ripple {\n  position: absolute;\n  left: calc(var(--v-slider-thumb-size) / -2);\n  top: calc(var(--v-slider-thumb-size) / -2);\n  width: calc(var(--v-slider-thumb-size) * 2);\n  height: calc(var(--v-slider-thumb-size) * 2);\n  background: inherit;\n}\n\n.v-slider.v-input--horizontal .v-slider-thumb {\n  top: 50%;\n  transform: translateY(-50%);\n  inset-inline-start: calc(var(--v-slider-thumb-position) - var(--v-slider-thumb-size) / 2);\n}\n.v-slider.v-input--horizontal .v-slider-thumb__label-container {\n  left: calc(var(--v-slider-thumb-size) / 2);\n  top: 0;\n}\n.v-slider.v-input--horizontal .v-slider-thumb__label {\n  bottom: calc(var(--v-slider-thumb-size) / 2);\n}\n.v-locale--is-ltr.v-slider.v-input--horizontal .v-slider-thumb__label, .v-locale--is-ltr .v-slider.v-input--horizontal .v-slider-thumb__label {\n  transform: translateX(-50%);\n}\n\n.v-locale--is-rtl.v-slider.v-input--horizontal .v-slider-thumb__label, .v-locale--is-rtl .v-slider.v-input--horizontal .v-slider-thumb__label {\n  transform: translateX(50%);\n}\n\n.v-slider.v-input--horizontal .v-slider-thumb__label > .v-slider-thumb__label-wedge {\n  clip-path: polygon(50% 100%, 0 50%, 100% 50%);\n  bottom: calc(-6px + 0.2px);\n}\n\n.v-slider.v-input--vertical .v-slider-thumb {\n  top: calc(var(--v-slider-thumb-position) - var(--v-slider-thumb-size) / 2);\n}\n.v-slider.v-input--vertical .v-slider-thumb__label-container {\n  top: calc(var(--v-slider-thumb-size) / 2);\n  right: 0;\n}\n.v-slider.v-input--vertical .v-slider-thumb__label {\n  top: -12.5px;\n  left: calc(var(--v-slider-thumb-size) / 2);\n}\n.v-slider.v-input--vertical .v-slider-thumb__label > .v-slider-thumb__label-wedge {\n  clip-path: polygon(0 50%, 50% 0, 50% 100%);\n  left: calc(-6px + 0.2px);\n}\n\n.v-slider-thumb--focused .v-slider-thumb__surface::before {\n  transform: scale(2);\n  opacity: var(--v-focus-opacity);\n}\n\n.v-slider-thumb--pressed {\n  transition: none;\n}\n.v-slider-thumb--pressed .v-slider-thumb__surface::before {\n  opacity: var(--v-pressed-opacity);\n}\n\n@media (hover: hover) {\n  .v-slider-thumb:hover .v-slider-thumb__surface::before {\n    transform: scale(2);\n  }\n  .v-slider-thumb:hover:not(.v-slider-thumb--focused) .v-slider-thumb__surface::before {\n    opacity: var(--v-hover-opacity);\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
